import type { StatsSnapshot } from './gameplay-snapshot';
import { useCurrencyStore } from '../store/zustand/useCurrencyStore';
import { CONFIG } from '../config';
import { multiplyAll } from '@game-libs/exc-libs/src/helpers/array.helpers';
import { unitStats as stats } from './index';

export const updateElfStats = (state: StatsSnapshot) => {
  const upgrades = state.upgrades.elf;
  const elf = state.generators.elf;

  const baseDamage = elf.baseGeneration + upgrades.multipleShot.multiplier;

  const criticalChance = upgrades.criticalChance?.multiplier || 0;
  const criticalMultiplier = upgrades.criticalDamage?.multiplier || 1;

  const currency = useCurrencyStore.getState();
  const inspirationMultiplier = currency.inspiration.remainingActive > 0 ? currency.inspiration.multiplier : 1;
  const damageMultiplier = multiplyAll([inspirationMultiplier]);

  const goldMultiplier = multiplyAll([upgrades.silverArrow.multiplier, upgrades.goldenArrow.multiplier]);

  const damagePerTick = baseDamage * damageMultiplier * elf.owned;

  const goldGeneration = damagePerTick * CONFIG.game.goldPerDamage * goldMultiplier;

  stats.elf = {
    mainIndividualGenerationStat: baseDamage * damageMultiplier,
    damagePerTick,
    goldGeneration,
    criticalChance,
    criticalDamage: criticalMultiplier * damagePerTick,
  };
};
